export const allowOnlyNumbers = (value) => {
  const rE = /^[0-9\b]+$/;
  return value === '' || rE.test(value);
};

export const isValidZipCode = (value) => {
  const isNumber = allowOnlyNumbers(value);
  if (!isNumber) {
    return { isNumber };
  }
  const valid = /^\d{5}-\d{4}$|^\d{5}$/.test(value);
  return { valid };
};

export const isValidEmail = (email) => new RegExp('^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,})+$').test(email);
export const isValidNumber = (num, minLength, maxLength) => {
  if (minLength >= 0 && maxLength >= 0) {
    return new RegExp(`^\\d{${minLength},${maxLength}}$`).test(num);
  }
  return new RegExp('^\\d+$').test(num);
};
